import { Form } from "react-router-dom";
import Box from "../components/Box/Box";
import BackButton from "../components/Buttons/BackButton";

export default function Fail() {

    return (
        <div>
            <Form>
                <Box>
                    <h2>Något gick fel!</h2>
                    <p>
                        Vi kunde tyvärr inte ta emot er överklagan just nu på grund av ett fel på vår sida. Vi ber er att prova senare alternativt
                        ringa till oss på telefonnummer <a href="tel:0771211010">0771 – 21 10 10</a> så hjälper vi er vidare.
                    </p>
                </Box>
                <div className="flex justify-center">
                    <div className="w-full text-left flex items-center">
                        <BackButton />
                    </div>
                </div>
            </Form>
        </div>
    );
}
